export default __webpack_public_path__ + "static/media/illustration_shipping-optimization.cc5ed639.svg";